import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import DeclarantInfoForm from 'modules/Declarant/components/DeclarantInfoForm';
import OperatorInfoForm from 'modules/Operator/components/OperatorInfoForm';
import { useTranslation } from 'react-i18next';
import { useOrganization } from '@clerk/clerk-react';
import { OrganizationType } from 'modules/Common/utils/Utility';
import ConsultantInfoForm from 'modules/Consultant/components/ConsultantInfoForm';
import { useFreemium } from 'modules/Common/freemium/FreemiumContext';

export default function OnboardingPage() {
  const history = useHistory();
  const { t } = useTranslation('app');
  const [step, setStep] = useState(1);
  const { organization } = useOrganization();
  const { triggerLimitExceeded } = useFreemium();

  const getUserForm = () => {
    if (organization?.publicMetadata?.type === OrganizationType.Declarant) {
      return <DeclarantInfoForm onSubmit={handleSubmit} />;
    } else if (organization?.publicMetadata?.type === OrganizationType.Consultant) {
      return <ConsultantInfoForm onSubmit={handleSubmit} />;
    } else {
      return <OperatorInfoForm onSubmit={handleSubmit} />;
    }
  };

  const handleSubmit = async (success) => {
    if (success) {
      await organization.reload();
      let url;
      if (organization?.publicMetadata?.type === OrganizationType.Declarant) {
        url = '/overview';
      } else if (organization?.publicMetadata?.type === OrganizationType.Consultant) {
        url = '/consultant-overview';
      } else {
        url = '/operator-installations';
      }
      triggerLimitExceeded();
      history.push(url);
    }
  };

  return (
    <div className="w-full px-3 mx-auto">
      <div className="grid grid-cols-12 gap-x-6 mt-12">
        <div className="col-span-12 md:col-span-8 md:col-start-3">
          <div className="rounded-lg border border-black/10 bg-white">
            <div className="text-center border-b border-black/10 px-4 py-2 bg-black/[.03]">
              {t('onboardingPage.welcome', 'Welcome to the Carbon Pricing Platform')}
            </div>
            <div className="p-4">
              <div className="h-4 overflow-hidden rounded bg-gray-200 mb-4">
                <div
                  className="h-full bg-primaryColor transition-[width]"
                  style={{ width: `${(step / 1) * 100}%` }}
                />
              </div>
              {step === 1 && (
                <div className="mt-5 mb-5">
                  <h5 className="pb-2">
                    {t('onboardingPage.fillInInformation', 'Fill in Information')}
                  </h5>
                  {getUserForm()}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
